module.exports = __webpack_public_path__ + "img/mystic.a977c5c7.png";